/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './Loader.css'
import { LOADING } from '../../../global/Icons';
import { SYNC_SERVICE } from '../../../global/Constants';

class SyncLoader extends Component {

    render() {
        // const { progress,tableName } = this.props;
        const { tableName } = this.props;
        let progress = (tableName === SYNC_SERVICE.MASTER_TABLE) ? 0 : (tableName === SYNC_SERVICE.KRISHAK_TABLE) ? 33 : 67
        return (
            <div className="loader-section">
                <div className="loader-content w-100">
                    <div className="row mt-3">
                        <div className="col-12 v-middle">
                            <div className="sync-img text-center mb-3">
                                <img src={LOADING} className="img-fluid" alt="sync img" />
                            </div>
                            <div className="progress progress-red1 w-75 m-auto">
                                <div className="progress-bar" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow={progress.toString} aria-valuemin="0" aria-valuemax="100">
                                    {progress}%
                                </div>
                            </div>
                            <div className="text-center mt-3">
                                <h6>{SYNC_SERVICE.SYNCHRONIZING} {tableName} {SYNC_SERVICE.DATA}</h6>
                                {/* <h6>{SYNC_SERVICE.SYNCHRONIZING} {SYNC_SERVICE.DATA}</h6> */}
                                <p>{SYNC_SERVICE.PLEASE_WAIT}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}
export default SyncLoader